// My Job — หน้าแรก แสดงแบรนด์ที่เปิดใช้งานไว้
import { useState } from "react";
import { Topbar } from "@features/navigation/components/topbar";
import { apiErrorMessage } from "@shared/api/client";
import { IconSearch } from "@shared/ui/icons";
import { useBrands } from "../api/use-brands";
import { BrandGrid, BrandGridError, BrandGridSkeleton } from "../components/brand-grid";
import { MyJobSidebar } from "../components/my-job-sidebar";

export function MyJobPage() {
  const { data, isPending, isError, error, refetch } = useBrands();
  const [q, setQ] = useState("");

  const term = q.trim().toLowerCase();
  // ค้นทั้งชื่อและคำอธิบาย — คนจำแบรนด์จากชื่อบริษัทในบรรทัดล่างก็มี
  const shown = term
    ? (data ?? []).filter((b) => `${b.name} ${b.tagline}`.toLowerCase().includes(term))
    : (data ?? []);

  return (
    <>
      <Topbar active="myjob" />
      {/* โครง layout เดียวกับหน้าแบรนด์/Setting — แถบซ้ายกางมาให้เองตามค่าที่จำไว้ */}
      <div className="layout">
        <MyJobSidebar />
        <main className="content" id="content">
          <div className="page-head">
            <div>
              <h1>My Brands</h1>
              <p className="subtitle">เลือกแบรนด์เพื่อเข้าสู่หน้าจัดการของแต่ละแบรนด์</p>
            </div>
            {/* กรองในหน้าเลย ไม่ต้องยิงใหม่ — รายการนี้โหลดมาครบแล้วตั้งแต่แรก */}
            <div className="search-box">
              <IconSearch />
              <input
                type="text"
                placeholder="ค้นหาแบรนด์…"
                value={q}
                onChange={(e) => setQ(e.target.value)}
              />
            </div>
          </div>

          <div className="section-label">
            {term ? `ผลการค้นหา · ${shown.length} แบรนด์` : "All Brands"}
          </div>
          <div className="brand-grid" id="brand-grid">
            {isPending && <BrandGridSkeleton />}
            {isError && <BrandGridError message={apiErrorMessage(error)} onRetry={refetch} />}
            {/* คำค้นไม่ตรงอะไรเลย ต่างจาก "ยังไม่มีแบรนด์" ที่ BrandGrid บอก — ไม่ควรชวนไปตั้งค่า */}
            {data &&
              (term && !shown.length ? (
                <div className="panel empty-state">
                  <h3>ไม่พบแบรนด์ที่ตรงกับ “{q.trim()}”</h3>
                  <p className="muted">ลองพิมพ์สั้นลง หรือค้นด้วยชื่อบริษัท</p>
                  <button type="button" className="btn-outline inline-btn" onClick={() => setQ("")}>
                    ล้างคำค้น
                  </button>
                </div>
              ) : (
                <BrandGrid brands={shown} />
              ))}
          </div>
        </main>
      </div>
    </>
  );
}
